var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollRef",
      staticClass: "horizontal-scroll-container",
      on: {
        mousedown: _vm.handleMouseDown,
        touchstart: _vm.handleTouchStart,
        touchmove: _vm.handleTouchMove,
        touchend: _vm.handleTouchEnd,
        touchcancel: _vm.handleTouchEnd,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }